import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fontawesome.min.css';
import App from './App';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://eb574522924983c2a1aa68e62d2c496f@o4511218524291072.ingest.de.sentry.io/4511218526060624",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
